export default __webpack_public_path__ + "static/media/password.9aca27ab.svg";